import { Routes } from '@angular/router';
import { authGuard } from '@modules/authentication/guards/auth.guard';

import { authenticationRoutes } from './modules/authentication/authentication.routes';

export const routes: Routes = [
    ...authenticationRoutes,

    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },

    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./core/layouts/shell/shell.component').then((c) => c.ShellComponent),
        children: [
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./modules/dashboard/pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
            },
            {
                path: 'finance',
                children: [
                    {
                        path: 'subscribers-income-statement',
                        loadComponent: () =>
                            import(
                                './modules/finance/pages/subscribers-income-statement/subscribers-income-statement.component'
                            ).then((c) => c.SubscribersIncomeStatementComponent),
                    },
                ],
            },
        ],
    },
];
